<template>
  <div
    class="player-container video_container"
    :class="{
      'full-screen': isFullScreen,
      vertical: isFullScreen && screenOrientation === 'vertical',
    }"
    v-wechat-title="($route.meta.title = pageTitle)"
  >
    <div v-show="playerReady" class="player-wrapper" ref="playerWrap">
      <video
        id="elm-yjPlayer"
        style="width: 100%; height: 100%"
        class="
          video-js
          vjs-big-play-centered vjs-default-skin vjs-theme-fantasy
          video-wrapper
        "
        :class="{ 'no-vjs-ctrl-bar': useCustomCtrlBar }"
        oncontextmenu="return false;"
        preload="auto"
        x5-video-player-type="h5-page"
        x5-video-player-fullscreen="true"
        webkit-playsinline="true"
        playsinline="true"
        ref="yjPlayer"
      ></video>
      <!-- 移动端显示的控制条 -->
      <div
        class="custom-contrl-bar-wrapper"
        v-if="useCustomCtrlBar"
        ref="customControlBar"
        :style="{ 'padding-bottom': isFullScreen ? '10px' : 0 }"
        :class="{ 'special-phone-tool': isFullScreen && isIosPhone }"
        @click.stop
        @touchstart.stop
        @dblclick.stop
      >
        <div class="ctrl-bar-main">
          <!-- 播放/暂停 -->
          <div
            class="play-control"
            :class="{
              'vjs-playing': videoPlayState === 'playing',
              'vjs-paused': videoPlayState === 'pause',
              'vjs-ended': videoPlayState === 'ended',
            }"
            @click.stop="handleVideoPlay(videoPlayState)"
          ></div>
          <!-- 当前时间/总时间 -->
          <div class="time-control">
            <span class="current-time">{{
              videoCurrentTime | playTimeStr
            }}</span>
            /
            <span class="max-time">{{ videoDuration | playTimeStr }}</span>
          </div>
          <!-- 进度条 -->
          <div class="process-control">
            <!-- 全部播放时，这个进度条会不可点击，组件bug -->
            <van-slider
              v-model="processSliderValue"
              active-color="#ff9645"
              :min="0"
              :max="100"
              @change="onProcessValueChange"
              v-show="!(isFullScreen && screenOrientation === 'vertical')"
            >
            </van-slider>
          </div>
          <!-- 全屏播放显示这个进度条 -->
          <div
            class="landscape-progress-bar"
            v-show="isFullScreen && screenOrientation === 'vertical'"
          >
            <van-slider
              v-model="processSliderValue"
              active-color="#ff9645"
              :min="0"
              :max="100"
              button-size="12"
              vertical
              @input="onProcessValueChange"
            />
          </div>
          <!-- 倍速 -->
          <div class="playback-rate-control" @click.stop="handlePlayRateOpt()">
            <span>{{ playRateOpt }}x</span>
          </div>
          <!-- 清晰度 -->
          <div
            class="resolution-control"
            @click.stop="showResolutions = !showResolutions"
          >
            <span>{{ curResolution }}</span>
            <div
              class="menu-box"
              v-if="videoSourceList.length"
              v-show="showResolutions"
              v-cloak
            >
              <template v-for="(item, index) in videoSourceList">
                <div
                  :key="index"
                  @click.stop="handleResolutionChange(item)"
                  class="text"
                  :class="{ current: item.label === curResolution }"
                >
                  {{ item.label }}
                </div>
              </template>
            </div>
          </div>
          <!-- 音量 -->
          <div
            class="muted-control"
            :class="[videoMuted ? 'off' : 'on']"
            @click.stop="handleMuted(videoMuted)"
          ></div>
          <!-- 全屏 -->
          <div
            class="fullscreen-control"
            :class="{ on: isFullScreen }"
            @click.stop="handleVideoFullScreen"
          ></div>
        </div>
      </div>
      <!-- 音频播放时的样式展示 -->
      <div
        v-if="lessonType === LESSON_TYPE.voice"
        ref="voiceLessonContentWrap"
        class="voice-lesson-info-wrapper-wrapper"
      >
        <div class="cover-zone" :style="coverStyle"></div>
        <div class="img-zone" :style="voiceStyle" @click.stop>
          <img :src="teacherImage || require('@/common/images/logo.png')" />
        </div>
      </div>

      <!-- 无音视频 -->
      <div
        v-if="cantPlay"
        class="no-player-wrapper video_container"
        @click.stop
        :style="{ width: width, height: height }"
        v-cloak
      ></div>
    </div>
    <!-- 暂停的广告 -->
    <div
      class="pause-adv-wrapper"
      v-show="showPauseAdvert"
      v-if="playPauseAdvData && playPauseAdvData.is_show"
    >
      <a class="main" :href="playPauseAdvData.jump_url">
        <i class="close-btn" @click.prevent.stop="openAdvertmodal(false)"></i>
        <img :src="playPauseAdvData.img_url" class="image" />
      </a>
    </div>
  </div>
</template>
<script>
import { Slider } from 'vant';

import {
  getVideoUrl,
  getVideoUrlNew,
  getCampSeriesSummary,
  getUserInfo,
} from '@/api/api';
import { isWechat, isMobile, isIos } from '@/common/js/utils';
import { LESSON_TYPE } from '@/common/js/config';
import { getSourceLabel, getSourceType } from '@/common/js/play-utils';
import campPlayCommon from '@/mixin/campPlayCommon';

import '@xiaoyexiang/videojs-resolution-switcher-v7/lib/videojs-resolution-switcher-v7.css';
import 'videojs-yojiang/dist/video-js.min.css';
import '@/common/css/videojs-themes/fantasy/index.css';

// eslint-disable-next-line import/order
import videojs from 'video.js';

window.videojs = videojs;

// eslint-disable-next-line import/extensions
require('videojs-yojiang/dist/lang/zh-CN.js');
require('@xiaoyexiang/videojs-resolution-switcher-v7');

let player = null;

export default {
  mixins: [campPlayCommon],
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '210px',
    },
    playPauseAdvData: {
      type: Object,
      default: () => ({}),
    },
    showWatermark: {
      type: Boolean,
      default: false,
    },
    // 自定义控制条，默认不展示
    showCustomControlBar: {
      type: Boolean,
      default: false,
    },
    recordPlayTime: {
      type: Boolean,
      default: true,
    },
    detailId: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 0,
    },
  },
  components: {
    [Slider.name]: Slider,
  },
  data() {
    return {
      isWechat: isWechat(),
      isMobile: isMobile(),
      isIosPhone: isIos(),
      player: null,
      // 课程ID
      seriesId: 0,
      // 单课ID
      currentLessonId: 0,
      LESSON_TYPE,
      played: false,
      playing: false,
      lastErrorCode: 0,
      videoSourceList: [],
      playerReady: false,
      playOptions: {
        width: this.width,
        height: this.height,
        muted: false,
        autoplay: false,
        controls: true,
        playbackRates: [0.75, 1, 1.25, 1.5, 2],
        language: 'zh-CN',
        label: '超清',
        plugins: {
          videoJsResolutionSwitcher: {
            dynamicLabel: true,
            default: 'high',
          },
        },
        sources: [],
        controlBar: {
          pictureInPictureToggle: false,
          volumePanel: {
            inline: false,
          },
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          audioTrackButton: false,
        },
        html5: {
          hls: {
            cacheEncryptionKeys: true,
            useBandwidthFromLocalStorage: true,
            keyResponseType: 'arraybuffer',
          },
        },
      },
      lessonId: 0,
      lessonType: 0,
      coverImage: '',
      teacherImage: '',
      sourceList: [],
      rotateVal: 0,
      rotateIndepVal: 0,
      portraitRotateEvent: null,
      cantPlay: false,
      showPauseAdvert: false,
      watermarkTimer: null,
      processSliderValue: 0,
      videoPlayState: 'pause',
      playRateOpt: 1.0,
      showResolutions: false,
      curResolution: '超清',
      videoMuted: false,
      videoDuration: 0,
      videoCurrentTime: 0,
      screenOrientation: 'vertical', // 竖屏，’transverse‘：横屏
      isFullScreen: false,
      videoCtrlBarTimer: null,
      userActive: null,
      userId: 0,
      nickname: '',
      poster: '',
      pageTitle: '',
      isOnce: true,
      voiceStyle: '',
    };
  },
  filters: {
    durationStr(duration) {
      const minute = Math.floor(duration / 60) < 10
        ? `0${Math.floor(duration / 60)}`
        : Math.floor(duration / 60);
      const seconds = duration % 60 < 10
        ? `0${Math.floor(duration % 60)}`
        : Math.floor(duration % 60);
      return `${minute}:${seconds}`;
    },
    playTimeStr(remainPlayTime) {
      const minutes = Math.max(Math.floor(remainPlayTime / 60), 0);

      // eslint-disable-next-line no-nested-ternary
      const seconds = remainPlayTime % 60 >= 10
        ? Math.floor(remainPlayTime % 60)
        : remainPlayTime % 60 > 0
          ? `0${Math.floor(remainPlayTime % 60)}`
          : '00';
      return `${minutes}:${seconds}`;
    },
  },
  computed: {
    coverStyle() {
      const res = `background: url(${this.teacherImage}) center no-repeat;`;
      return res;
    },
    useCustomCtrlBar() {
      return (
        this.showCustomControlBar
        && isWechat()
        && isMobile()
        && this.lessonType === LESSON_TYPE.video
      );
    },
  },
  mounted() {
    window.addEventListener(
      'deviceorientation',
      this.orientationListener,
      false
    ); // 方向感应器

    window.addEventListener('MozOrientation', this.orientationListener, false); // 方向感应器 for firefox
    window.addEventListener('devicemotion', this.orientationListener, false); // 重力加速感应器 for iphone, android
    // 移动端监测手机屏幕旋转
    window.addEventListener(
      'orientationchange',
      () => {
        // 横屏
        if (window.orientation === 90 || window.orientation === -90) {
          this.screenOrientation = 'transverse';
        } else if (window.orientation === 0 || window.orientation === 180) {
          // 竖屏
          this.screenOrientation = 'vertical';
          this.isFullScreen = false;
        }
      },
      false
    );

    // 页面隐藏的时候暂停播放音视频
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.handleVideoPlay('playing');
      }
    });

    this.currentLessonId = this.lessonId;
    this.handleComponentEvent();
    getUserInfo().then((res) => {
      this.userId = res.id;
      this.nickname = res.nickname;
    });
  },
  methods: {
    initializeData() {
      this.rotateVal = 0;
      this.rotateIndepVal = 0;
      this.cantPlay = false;
      this.playerReady = false;
      if (this.portraitRotateEvent) {
        clearInterval(this.portraitRotateEvent);
      }
    },
    handleComponentEvent() {
      this.lessonType = +this.$route.query.lt;
      this.lessonId = this.$route.params.lesson_id;
      this.seriesId = +this.$route.query.sid;

      if (this.lessonType === LESSON_TYPE.video) {
        getVideoUrlNew(this.lessonId).then((resData) => {
          const videoUrls = resData.video_urls;

          if (!videoUrls.length) {
            this.cantPlay = true;
            this.emitPlayStatus(false);
          }

          this.poster = resData.cover_url;
          this.videoDuration = resData.lesson.video_duration;
          this.setupVideoJs(videoUrls, this.width, this.height);
        });
      } else if (this.lessonType === LESSON_TYPE.voice) {
        getVideoUrl(this.lessonId).then((resData) => {
          if (!resData.lesson.audio_url) {
            this.cantPlay = true;
            this.emitPlayStatus(false);
          }

          this.videoSourceList.unshift({
            src: resData.lesson.audio_url,
            label: '音频',
            res: 360,
            type: 'audio/mp3',
          });

          this.setupVideoJs(this.videoSourceList, this.width, this.height);
        });
      } else {
        this.cantPlay = true;
        this.playerReady = true;
        this.emitPlayStatus(false);
        return;
      }

      getCampSeriesSummary(this.seriesId).then((resData) => {
        this.coverImage = resData.cover_image;
        this.teacherImage = resData.teacher_image;
        this.pageTitle = resData.name;
      });
    },
    emitPlayStatus(playing) {
      this.$emit('handle-play', playing);
    },
    setupVideoJs(videoUrls, width, height) {
      if (this.lessonType === LESSON_TYPE.video) {
        videoUrls.forEach((element) => {
          const source = {};

          // 线上协议替换
          if (
            element.src.indexOf('http:') > -1
            && window.location.protocol === 'https:'
          ) {
            element.src = element.src.replace('http:', 'https:');
          }

          // 阿里OSS 自转码视频资源
          if (typeof element === 'object' && element.definition) {
            let res = 0;
            let label = '';
            // eslint-disable-next-line default-case
            switch (element.definition) {
              case 5:
                label = '流畅';
                res = 640;
                break;
              case 4:
                label = '标清';
                res = 960;
                break;
              case 3:
                label = '高清';
                res = 1280;
                break;
              case 2:
                label = '超清';
                res = 1920;
                break;
              case 1:
                label = '原画';
                res = 2048;
                break;
            }
            source.src = element.src;
            source.type = getSourceType(element.src);
            source.label = label;
            source.res = res;
          } else {
            // 腾讯云视频资源
            source.src = element;
            source.type = getSourceType(element);
            source.label = getSourceLabel(element).label;
            source.res = getSourceLabel(element).res;
          }
          this.videoSourceList.unshift(source);
        });
      }

      const playerOptions = {
        controls: true,
        autoplay: false,
        preload: 'auto',
        width,
        height,
        playbackRates: [0.75, 1, 1.25, 1.5, 1.75, 2],
        language: 'zh-CN',
        label: '',
        plugins: {
          videoJsResolutionSwitcher: {
            dynamicLabel: true,
            default: 'low',
          },
        },
        sources: this.videoSourceList,
        controlBar: {
          pictureInPictureToggle: false,
          volumePanel: {
            inline: false,
          },
        },
      };

      if (this.lessonType === LESSON_TYPE.video) {
        playerOptions.poster = this.poster;
      }
      if (this.lessonType === LESSON_TYPE.voice) {
        playerOptions.controlBar.fullscreenToggle = false;
      }

      this.$nextTick(() => {
        this.player = videojs(this.$refs.yjPlayer, playerOptions, () => {
          // eslint-disable-next-line prefer-destructuring
          player = this.player;
          let currentTimeTimer = null;
          if (this.recordPlayTime) {
            this.init(this.lessonId, this.detailId, this.player);
          }

          this.player.on('play', () => {
            if (this.recordPlayTime && !this.playing && this.isOnce) {
              this.restorePlayerTime();
            }

            this.isOnce = false;
            this.played = true;

            if (this.lessonType === LESSON_TYPE.voice) {
              this.voiceTimer = setInterval(() => {
                this.rotateVal += 2;

                if (this.rotateVal > 360) {
                  this.rotateVal -= 360;
                }

                this.voiceStyle = `transform: rotate(${this.rotateVal}deg);`;
              }, 30);
            }

            // 视频水印处理
            if (this.showWatermark && this.lessonType === LESSON_TYPE.video) {
              if (this.watermarkTimer) {
                clearInterval(this.watermarkTimer);
              }

              setTimeout(this.setVideoWatermark, 1000);
              this.watermarkTimer = setInterval(this.setVideoWatermark, 9000);
            }

            if (this.recordPlayTime) {
              const startTime = Math.floor(Date.now() / 1000);
              try {
                this.startLessonPlayerTime(startTime);
              } catch (err) {
                console.error(`Exception:${err.message}<br>${err.stack}`);
              }
            }
          });

          this.player.on('playing', () => {
            this.playing = true;
            this.videoPlayState = 'playing';
            this.openAdvertmodal(false);
            currentTimeTimer = setInterval(() => {
              this.videoCurrentTime = player.currentTime();

              this.processSliderValue = (this.videoCurrentTime * 100) / this.videoDuration;
            }, 1000 / this.playRateOpt);

            this.emitPlayStatus(true);
          });

          this.player.on('pause', () => {
            this.playing = false;
            this.videoPlayState = 'pause';
            this.customClearInterval(currentTimeTimer);

            this.emitPlayStatus(false);

            this.openAdvertmodal(true);

            if (this.lessonType === LESSON_TYPE.voice) {
              clearInterval(this.portraitRotateEvent);
              clearInterval(this.voiceTimer);
            }

            // 视频水印处理
            if (this.showWatermark && this.lessonType === LESSON_TYPE.video) {
              this.eraseWatermark();

              this.customClearInterval(this.watermarkTimer);
            }

            if (this.recordPlayTime) {
              try {
                this.stopLessonPlayerTime();
              } catch (err) {
                console.log(`Exception:${err.message}<br>${err.stack}`);
              }
            }
          });

          this.player.on('resolutionchange', () => {
            this.customClearInterval(currentTimeTimer);
          });

          // this.player.on('loadedmetadata', () => {
          //   if (this.recordPlayTime && !this.playing) {
          //     this.restorePlayerTime();
          //   }
          // });

          this.player.on('fullscreenchange', () => {
            // 视频水印处理
            if (this.showWatermark && this.lessonType === LESSON_TYPE.video) {
              this.eraseWatermark();
              this.customClearInterval(this.watermarkTimer);
              setTimeout(this.setVideoWatermark, 5000);
              this.watermarkTimer = setInterval(this.setVideoWatermark, 9000);
            }
          });

          this.player.on('ended', () => {
            this.videoPlayState = 'ended';
            this.emitPlayStatus(false);

            clearInterval(this.voiceTimer);

            if (this.recordPlayTime) {
              try {
                const endTime = Math.floor(Date.now() / 1000);
                this.stopLessonPlayerTime(endTime);
              } catch (err) {
                console.error(`Exception:${err.message}<br>${err.stack}`);
              }
            }
          });

          this.player.on('error', (event) => {
            console.error('[错误]');
            console.error(event);
          });

          this.player = (err) => {
            if (err === null) {
              return;
            }

            try {
              console.error(`err=${err}`);
              console.error(`code=${err.code}`);
              console.error(`message=${err.message}`);
            } catch (_err) {
              console.error(`_err=${_err}`);
            }

            if (err && err.code !== this.lastErrorCode) {
              this.lastErrorCode = err.code;
            }

            if (err && err.code === 4) {
              if (!this.played) {
                const currentRes = this.player.currentResolution();
                let currentSrc = currentRes.src;
                if (
                  !currentSrc
                  && currentRes.sources
                  && currentRes.sources.length === 1
                ) currentSrc = currentRes.sources[0].src;

                if (currentSrc) {
                  console.log(`[去掉出错播放源]${currentSrc}`);
                }

                const newSources = [];
                this.videoSourceList.forEach((source) => {
                  if (currentSrc !== source.src) {
                    newSources.push(source);
                  }
                });

                this.videoSourceList = newSources;
                if (
                  !this.videoSourceList
                  || this.videoSourceList.length === 0
                ) {
                  console.log('[没有可用视频源]');
                } else {
                  this.player.updateSrc(this.videoSourceList);
                }
              } else {
                console.log('格式不支持');
              }
            } else {
              console.log('出错恢复');
            }
          };

          this.playerEl = this.$refs.playerWrap.querySelector('#elm-yjPlayer');
          try {
            if (this.lessonType === LESSON_TYPE.voice) {
              this.vjsPoster = this.playerEl.querySelector('.vjs-poster');
              this.voiceLessonContentWrap = this.$refs.voiceLessonContentWrap;
              this.playerEl.insertBefore(
                this.voiceLessonContentWrap,
                this.vjsPoster
              );
            }
            if (this.useCustomCtrlBar) {
              this.vjsPlayBtn = this.playerEl.querySelector(
                '.vjs-big-play-button'
              );
              this.customControlBar = this.$refs.customControlBar;
              this.playerEl.insertBefore(
                this.customControlBar,
                this.vjsPlayBtn
              );
            }
          } catch (err) {
            console.error(err);
          }

          this.playerReady = true;
        });
      });
    },
    openAdvertmodal(open = false) {
      if (!this.playPauseAdvData.is_show) {
        return;
      }
      this.showPauseAdvert = open;
    },
    // 视频水印
    eraseWatermark() {
      const dom = document.getElementsByClassName('video-wrapper')[0];
      const oldBox = document.getElementsByClassName('watermark-box')[0];
      if (oldBox) {
        dom.removeChild(oldBox);
      }
    },
    setVideoWatermark() {
      const dom = document.getElementsByClassName('video-wrapper')[0];
      // eslint-disable-next-line radix
      const parentWidth = parseInt(dom.getBoundingClientRect().width);
      const oldBox = document.getElementsByClassName('watermark-box')[0];
      if (oldBox) {
        dom.removeChild(oldBox);
      }

      const boxElem = document.createElement('div');
      boxElem.setAttribute('class', 'watermark-box');
      boxElem.style.pointerEvents = 'none';
      dom.appendChild(boxElem);
      boxElem.style.position = 'absolute';

      boxElem.addEventListener('dblclick', (e) => {
        e.preventDefault();
        e.stopPropagation();

        return false;
      });

      // 格式：Math.floor( Math.random() * (m-n) + n ) + 1
      // Math.floor(Math.random()*(-35)+85) + 1; //50（不包含）到85（包含）随机数字
      const randomTopR = Math.floor(Math.random() * (19 - 70) + 70) + 1;
      const randomLeftR = Math.floor(Math.random() * (1 - 100) + 100) + 1;

      boxElem.style.fontWeight = 500;
      boxElem.style.fontSize = '16px';
      boxElem.style.lineHeight = '16px';
      boxElem.style.color = 'rgba(255, 255, 255, 0.5)';
      boxElem.style.webkitTextStrokeWidth = '1px';
      boxElem.style.webkitTextStrokeColor = 'rgba(25, 25, 25, 0.4)';
      boxElem.style.whiteSpace = 'nowrap';
      // 昵称
      const elem1 = document.createElement('div');
      elem1.setAttribute('class', 'nickname');
      elem1.style.pointerEvents = 'none';
      elem1.innerHTML = `昵称：${this.nickname}`;
      boxElem.appendChild(elem1);
      const elem1Width = elem1.getBoundingClientRect().width;
      // ID
      const elem2 = document.createElement('div');
      elem2.setAttribute('class', 'user-id');
      elem2.style.pointerEvents = 'none';
      elem2.innerHTML = `ID：${this.userId}`;
      boxElem.appendChild(elem2);
      elem2.style.marginTop = '6px';

      boxElem.style.top = `${randomTopR}%`;
      boxElem.style.left = `${
        randomLeftR * 0.01 * (parentWidth - elem1Width)
      }px`;
    },
    onProcessValueChange(value) {
      this.processSliderValue = value;

      this.videoCurrentTime = Math.min(
        (this.videoDuration * value) / 100,
        this.videoDuration
      );

      if (this.videoPlayState === 'ended') {
        this.videoPlayState = 'pause';
      }
      player.currentTime(this.videoCurrentTime);
    },
    // 视频播放/暂停
    handleVideoPlay(videoPlayState) {
      if (videoPlayState === 'playing') {
        player.pause();
        this.videoPlayState = 'pause';
      } else if (videoPlayState === 'pause') {
        player.play();
        this.videoPlayState = 'playing';
      } else if (videoPlayState === 'ended') {
        player.play();
        this.videoPlayState = 'playing';
      }
    },
    // 视频播放倍数
    handlePlayRateOpt() {
      if (this.playRateOpt === 2.0) {
        this.playRateOpt = 0.5;
      } else {
        this.playRateOpt += 0.25;
      }

      player.playbackRate(this.playRateOpt);
    },
    // 视频源切换
    handleResolutionChange(item) {
      if (item.label === this.curResolution) {
        return;
      }
      player.currentResolution(item.label);
      this.curResolution = item.label;
      this.showResolutions = false;
      // this.playRateOpt = 1.0;
      player.play();
    },
    // 视频音量开启/关闭
    handleMuted(videoMuted) {
      if (videoMuted) {
        player.muted(false);
      } else {
        player.muted(true);
      }
      this.videoMuted = !videoMuted;
    },
    // 视频全屏播放
    handleVideoFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    // 检查移动设备是否支持重力方向感应
    orientationListener(e) {
      if (e.type === 'devicemotion') {
        window.removeEventListener(
          'devicemotion',
          this.orientationListener,
          false
        );

        // 横屏
        if (window.orientation === 90 || window.orientation === -90) {
          // console.log('横屏');
          this.screenOrientation = 'transverse';
        } else if (window.orientation === 0 || window.orientation === 180) {
          // console.log('竖屏');
          this.screenOrientation = 'vertical';
        }
      } else if (
        e.type === 'deviceorientation'
        || e.type.toLowerCase() === 'mozorientation'
      ) {
        window.removeEventListener(
          'deviceorientation',
          this.orientationListener,
          false
        );
        window.removeEventListener(
          'MozOrientation',
          this.orientationListener,
          false
        );

        if (window.orientation === 90 || window.orientation === -90) {
          // console.log('横屏');
          this.screenOrientation = 'transverse';
        } else if (window.orientation === 0 || window.orientation === 180) {
          // console.log('竖屏');
          this.screenOrientation = 'vertical';
        }
      }
    },
    handleClassChange(userActive) {
      if (userActive === 'user-active') {
        this.userActive = 'user-inactive';
      } else if (userActive === 'user-inactive') {
        this.userActive = 'user-active';
      } else {
        this.userActive = 'user-inactive';
      }
      setTimeout(() => {
        this.userActive = null;
      }, 3000);
    },
    /**
     * @description 清除定时器
     * @param {object} obj 定时器对象
     */
    customClearInterval(obj) {
      if (obj) {
        clearInterval(obj);
      }
    },
  },
  beforeDestroy() {
    this.stopLessonPlayerTime();
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.player-container {
  position: relative;

  &.full-screen {
    position: fixed;
    z-index: 1002;

    &.vertical {
      min-width: 100vh !important;
      min-height: 100vw !important;
      left: 100%;
      transform: rotate(90deg);
      transform-origin: 0 0; /* (0, 0)为旋转点 */
      margin: 0;
    }

    .player-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1002;
    }
  }
}

.player-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.custom-contrl-bar-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(43, 51, 63, 0.7);
  display: none;

  .ctrl-bar-main {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 34px;

    .play-control {
      &:hover {
        cursor: pointer;
      }

      width: 40px;
      height: 30px;

      &.vjs-paused {
        background: url('../../common/css/videojs-themes/fantasy/icons/feed_icon_paly.png') center center no-repeat;
        background-size: 18px;
      }

      &.vjs-playing {
        background: url('../../common/css/videojs-themes/fantasy/icons/feed_icon_pause.png') center center no-repeat;
        background-size: 18px;
      }

      &.vjs-ended {
        background: url('../../common/css/videojs-themes/fantasy/icons/feed_icon_replay.png') center center no-repeat;
        background-size: 18px;
      }
    }

    .time-control {
      color: #fff;
      font-size: 12px;

      .current-time {
        display: inline-block;
        width: 40px;
        text-align: right;
      }

      .max-time {
        display: inline-block;
        width: 40px;
        text-align: left;
      }
    }

    .process-control {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex: 1;
      padding: 0 6px;

      /deep/ .van-slider__button {
        width: 12px;
        height: 12px;
      }

      .custom-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        background-color: rgba(255, 150, 69, 0.36);
        border-radius: 100%;

        &::before {
          content: '';
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: rgba(255, 150, 69, 1);
          border-radius: 100%;
        }
      }
    }

    .playback-rate-control {
      &:hover {
        cursor: pointer;
      }

      width: 40px;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }

    .resolution-control {
      &:hover {
        cursor: pointer;
      }

      position: relative;
      width: 40px;
      height: 30px;
      color: #ccc;
      font-size: 12px;
      text-align: center;
      line-height: 30px;

      .menu-box {
        position: absolute;
        left: -8px;
        bottom: 30px;
        width: 56px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 4px;
        font-size: 14px;

        .text {
          &:hover {
            cursor: pointer;
            background-color: rgba(115, 133, 159, 0.5);
          }

          &.current {
            color: #ff9645;
            background: transparent;
          }
        }
      }
    }

    .muted-control {
      width: 40px;
      height: 30px;

      &.on {
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAgpJREFUaAXtmL9KA0EQxhMV/Bc7LQwoeQMNwUIECytFUKwEIa22WvoCNuIbWCrpFG3sBC3ERkWfIFhooY0Y7CT+FjaybLzNTpKDFXbh4252Zme/+S53N7lMJo6oQFQgKhAViApEBaIC4StQr9d7wQwYDZ+txRDSE+AOqFEDc1ZIuCZkS+AFmOO4W4x7upXorzwwXmX+Coxb/hHLbttMrQDI78DqBAy72BGXB+ug3xWX5OtLciTNs5FaMw3ySTHML4NNh990HWIsgQrYMB1dP4f8JHgCnY7zBjkS7RvJ1hrzqRzZ6MzYrJNTs4Aciao62b2UuPQeWJBu0Co+m83WiNnTcUUKET1ipQXkWhFq03/Eui+9dlGSQ1qAJLd3LFdBkb/VC+a9FxIYRAGa8KM+FvTR6xBSAW+asahXCqkAL8XtoJAKGNPk3m2SLjukAqY00aqLsO0LogCe/UMQm9Xkrm2SLltagHrppDHKJB3UiS8kG0gLuJQk94lFfdVa7+rYB94JNz7r2ophM9XMPYJOh9kLHRjJxM2cqJ1GnWc2K1G9uuFatdNbnioVdVyF/Keea9IPo9Bt8G2oa56aV6CAowwG0mcl3AFSK0D9ibfHbwHClE3h0pu4KYFrgp+EIqqas1cr7sOywzaR3/ys8okt6vmDqA7S//fDVhAKRhJRgahAVCAqEBWICqSgwA+GO9bzQT25sQAAAABJRU5ErkJggg==') center no-repeat;
        background-size: 22px;
      }

      &.off {
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAlpJREFUaAXtmL9LHEEUxz0UNP4AC4WoGIs0V0QEg42prQRFEQRJrZVgakvTCfaCnSheE7DQQrHwDzCQxlobLbQzsdPz83DueLs35+2st3e7YQa+zu957/PW2Z25lhaffAR8BHwEfAR8BP7nCBSLxV60gNozyYnj60jSCerIHAROf0a3SFJsCOa2ognU1/AgYDSPYkMwdxhdIEl/0bfMQODsV3SDdNprOIAYxAOnJ8H4WSQRD6fDpgC4QODxD/QU9tzUywDUB9EiasxbDkNt6AsK7AnqA2jGaJv8raQBjs3A/cSfCoZG0CUqoDBEN20HKErSAJtqwlyiEBg6UsbeA6EBBPzKrPs7aYBHBSDFuBBlALOvltW6yb1ilRFdjAMRBuhkwX9m0Y3EnoL2OlR2hQgAmKdwZtY8bwaA2JYNHHVj2wC2DMC1C0Cby+AaYxdN/xT5KZL8F5pHkkr9r7XKv3emyemsVE8AsV9yMi5EJVaNlnoDvAei3/h6X8PnQHcSAFEgPgS8eK2MmbYrS199mswmc8mqbezv2iMWlNdo6RuT6Gv0wcV7M9YGEbjZMW5FrTup4epaxsihMuRSrArBIj2oYUeJTxj74+K5GmuFoH9VjZlzjXjOdQLGZOPLhht8Y+40fSuW/gJtP5F8Jz6aXL4TO+g5l8stkacjAbqGbBca25OQE2lXOjxXXuCUXHBsV0o5NuRR4FKkpqaniJPjKHyp3xUPswShf1aRV3H5zJ8liKo/bFkgWtPzPxTRkxDEaMRp6RoGxBCaTZdX3hsfAR8BHwEfAR+BBCPwAr6ijx4XgCimAAAAAElFTkSuQmCC') center no-repeat;
        background-size: 22px;
      }
    }

    .fullscreen-control {
      width: 40px;
      height: 30px;
      background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAUtJREFUaAXtWckNwjAQTCiBd4rhG/qgBYqgBAqgDnoJxwtaCLMSjnIoI4yTlR9jyfKx3t3ZmURylKJQEwNiQAxky0DbthX6Bf2B/m9r4Lh3LxJJDfzrX9Qjv/taBWxI4BNsW2LPwsQK2C2E8IY4h4ViTcKUk53vhj0CfVuJ1l/nMmcK5IKR4lABlB4HoxRwIJmmkAKUHgejFHAgmaaQApQeB2O2CuAqVqPbt4T1OpoLOA1adIBEByQ34KE10eHgmRYgOuPQISAP49D6wwqOaRL+kIMdCcDDOHc2yzu+gTXgfdBz3yPZvsR98GyuAhg7HjYp4MEyyyEFGDseNingwTLLIQUYOx621RTAVSZcBsN9LGocFf8crbvlagUgwxm96jKlTa5z7msWMJczdv8Nh2OsU/L51EcI/vZby35vLaVick0KIAbEgBiYMvABJu+asgmE2EgAAAAASUVORK5CYII=') center no-repeat;
      background-size: 14px;

      &.on {
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAVRJREFUaAXtWNsNwjAMJLAB32UXPimDsAFLMAIDwBqsAgUkPhATQDlLpIoqoUSuHVrkSFaevth3qZp2NLLyJwzUdb2AnWAVbDm4tBD0EebLJVcCTmojRP4E1jjAmzjnXkFfpRluqLKBNqgloM1wDN8UiDGkPW8KaDMcwzcFYgxpz5sC2gzH8E2BGEPa840CuE2WMLrLswoCbbDQvuW4iRI54aZb9AsaFCgHAYwkiDCBJIeERQ+sWSesk12Cc9PpCMH/CtvDZrKRGZoxYAz0hgE84AVsB6MHnlvoXVVmTwqbUvB3btQtv8onoPEe8NjteoOBaXuwaz9nAvOuwX78z6hXHkvsz5wH/FbTEQjncFcS2TunAmH8Ym1LQIxKJpApwCROzM0UEKOSCWQKMIkTczMFxKhkApkCTOLE3HIqQNdgX8K2H+t3jdu0/+/0m0/CftMz4Oje9kte/v9XNrEAAAAASUVORK5CYII=') center no-repeat;
        background-size: 14px;
      }
    }
  }
}

/deep/ .no-vjs-ctrl-bar .vjs-control-bar {
  display: none !important;
}

.vjs-has-started .custom-contrl-bar-wrapper {
  display: flex;
  visibility: visible;
  opacity: 1;
  transition: visibility 0.1s, opacity 0.1s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .custom-contrl-bar-wrapper {
  visibility: visible;
  opacity: 0;
  transition: visibility 1s, opacity 1s;
}

.vjs-controls-disabled .custom-contrl-bar-wrapper, .vjs-error .custom-contrl-bar-wrapper, .vjs-using-native-controls .custom-contrl-bar-wrapper {
  display: none !important;
}

.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .custom-contrl-bar-wrapper {
  opacity: 1;
  visibility: visible;
}

.voice-lesson-info-wrapper-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.42);
  overflow: hidden;

  .cover-zone {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10%;
    left: -10%;
    width: 120%;
    height: 120%;
    filter: blur(40px);
    background-size: cover !important;
  }

  .img-zone {
    position: absolute;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    width: 80px;
    height: 80px;
    // border-radius: 100%;
    background-size: cover !important;
    transform-origin: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      user-select: none;
      border-radius: 50%;
    }
  }
}

.virtual-click-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: pink;
}

.no-player-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  background: url('./no_lesson_bg@2x.png') center no-repeat;
  background-size: cover;
}

.pause-adv-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 40px);
  z-index: 100;

  .main {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 10;
    width: 92%;
    min-width: 260px;
    max-width: 345px;
    transform: translate(-50%, -50%);

    .close-btn {
      display: block;
      position: absolute;
      right: -25px;
      top: -25px;
      z-index: 2;
      width: 50px;
      height: 50px;
      background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAASFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABKSkpMTEyGhobAwMDS0tLT09Pa2toEYG6KAAAAF3RSTlMAAQMIDRskKj1CTlFSVl5jZoCAoNfy8uFFOFkAAADuSURBVDjLjZTdFkQwDISHRdVPZYv0/d90L7bIptbJ3HD4MDJJAKHG+SksS5i8a3CrqhtIaOiqkmlnUppbhdQ93aivJfMa6VbjSzAz/dF8UvVIfzUeX+zpQX3+L3pUCwBVNrRuUd6L25ptVQC6fHVLLKjIacunHYCjzm8WVOTE76P2QHM9vJ9U5LRfr23gqKR+GXLwVFCKIY+JNKUZmhBIU5qhgIU0pRlaCojTT72+UNDMvmsqKOP8Nc7KuNfMeRAlcAVTUE7GwjIWlrGcAUcdcLwCtrWKqelM7WsbBNtImYbTNua2hWFbPcYl9rQOPzmCQjFaU09cAAAAAElFTkSuQmCC') center center no-repeat;
      -webkit-background-size: 18px;
      background-size: 18px;
    }

    .image {
      display: block;
      width: 100%;
      height: auto;
      margin: auto;
      object-fit: cover;
    }
  }
}

.landscape-progress-bar {
  position: fixed;
  top: calc(100vw - 10px);
  left: 150px;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 325px);
  width: 30px;
  transform: rotate(-90deg);
  transform-origin: 0 0; /* (0, 0)为旋转点 */
}

.landscape-progress-bar-ios {
  top: calc(100vw - 10px);
  //left: 38vw;
  //height: 80vw;
}

.special-phone-tool {
  //margin-left: 40px !important;
  //width: calc(100% - 40px) !important;
  width: 100%;
}

/deep/ .vjs-theme-fantasy .vjs-big-play-button {
  z-index: 1003;
}

/deep/ .vjs-theme-fantasy .vjs-control-bar {
  z-index: 1001;
  outline-width: 0 !important;
}

/deep/ .video-js .vjs-slider:focus {
  box-shadow: none;
  outline: none;
}

.video_container {
  width: 100vw !important;
  max-width: 640px !important;
  height: 56vw !important;
  max-height: 360px !important;
}
</style>
